'use client';

import { SessionTimeoutWarningModal } from './SessionTimeoutWarningModal';
import type { SessionTimeoutHookProps } from './SessionTimeout.types';
import { useSessionTimeout } from './useSessionTimeout';

/**
 * Runs the session clock and renders the warning when one is due.
 *
 * Split from `SessionTimeoutWatcher` so the timer hooks are only ever instantiated once the
 * watcher's auth and browser gates have all passed — a guest or a server render never reaches
 * this component, and so never starts an interval or reads `localStorage`.
 */
export const SessionTimeout = (props: SessionTimeoutHookProps) => {
  const { phase, reason, secondsRemaining, canExtend, onStaySignedIn, onSignOutNow } =
    useSessionTimeout(props);

  if (phase !== 'warning' || reason === null) return null;

  return (
    <SessionTimeoutWarningModal
      reason={reason}
      secondsRemaining={secondsRemaining}
      canExtend={canExtend}
      onStaySignedIn={onStaySignedIn}
      onSignOutNow={onSignOutNow}
    />
  );
};

SessionTimeout.displayName = 'SessionTimeout';
